import {useEffect, useRef} from 'react'
import useQrScanner from 'shared/hooks/useQrScanner'
import QrScanStyles from 'shared/style/qrScanStyles'
import QrScannerVideo from 'shared/ui/QrScannerVideo'
import QrScannerError from 'shared/ui/QrScannerError'
import QrScannerControls from 'shared/ui/QrScannerControls'
import QrScannerInstructions from 'shared/ui/QrScannerInstructions'
import useHandlePostScanQR from 'entity/event/useHandlePostScanQR'
import usePostScanUserQR from 'entity/event/usePostScanUserQR'
import TournamentBottomSheet from 'shared/ui/ScanResultBottomSheet/TournamentBottomSheet'

const QrScanTour = () => {
	const {
		isInitializing,
		scannedData,
		error,
		hasScannedData,
		videoRef,
		clearAndRescan,
	} = useQrScanner()

	const [
		postScanQR,
		scanResult,
		isLoading,
		clearScanResult,
		isBottomSheetOpen,
		handleRefetch,
	] = usePostScanUserQR(clearAndRescan)

	// Track if we've already made API call for current scan
	const hasCalledApiRef = useRef(false)

	useHandlePostScanQR(
		hasScannedData,
		scannedData,
		scanResult,
		isBottomSheetOpen,
		hasCalledApiRef,
		postScanQR
	)

	// Reset API call flag when starting a new scan
	useEffect(() => {
		if (!hasScannedData) {
			hasCalledApiRef.current = false
		}
	}, [hasScannedData])

	const handleClearAndRescan = () => {
		clearScanResult()
		clearAndRescan()
	}

	return (
		<>
			<QrScanStyles.Container>
				<QrScanStyles.Title>
					참가자 토너먼트 티켓 QR 코드 스캔
				</QrScanStyles.Title>

				<QrScannerVideo
					videoRef={videoRef}
					isLoading={isLoading}
					isInitializing={isInitializing}
				/>

				<QrScannerError error={error} />

				<QrScannerControls
					hasScannedData={hasScannedData}
					onRescan={clearAndRescan}
					isLoading={isLoading}
				/>

				<QrScannerInstructions instructions={instructions} />
			</QrScanStyles.Container>

			{isBottomSheetOpen && scanResult && (
				<TournamentBottomSheet
					isOpen={isBottomSheetOpen}
					// isOpen={true}
					onClose={handleClearAndRescan}
					// scanData={exampleData}
					scanData={scanResult}
					handleRefetch={handleRefetch}
					isLoading={isLoading}
					clearAndRescan={handleClearAndRescan}
				/>
			)}
		</>
	)
}

export default QrScanTour

const instructions = [
	'참가자가 제시한 유효한 토너먼트 티켓을 확인하세요.',
	'QR 코드를 잘 볼 수 있도록 카메라를 위치시키세요.',
	'스캔 후, 플레이어 정보를 검토하고 참가/퇴장 처리를 하세요.',
]

export const exampleData = {
	user_info: {
		idx: 1315,
		nickname: 'user2z',
		name: 'user2',
		contact: '01051541552',
		profile_img:
			'https://orcalabs.s3.ap-northeast-2.amazonaws.com/profile_image/1755585837503.jpg',
		pro_grade_flag: 1,
	},
	participation_tickets_count: 1,
	store_tickets_count: 0,
	store_tickets_breakdown: {
		typed_tickets: 0,
	},
	eligible_competitions: [
		{
			type: 'participation_ticket',
			event_idx: 94,
			event_name: 'Shockwaves concert [OFFICAL]',
			event_date: '2025-10-31T14:04:00.000Z',
			event_state: 1,
			max_entry: null,
			required_tickets: 1,
			pro_grade_required: 1,
			ticket_info: {
				serial_number: 'aa831b2b-38fd-4304-ac57-189c4a885b8e',
				ticket_idx: 1693,
			},
			event_timer: {},
			series_info: {
				series_name: 'RACING TO THE DARK',
				series_start_date: '2025-09-03T00:00:00.000Z',
				series_end_date: '2025-10-31T00:00:00.000Z',
			},
			participation_history: {
				count: 0,
				max_reentry: null,
				remaining_reentries: null,
				participation_map: [],
			},
			available_tickets: {
				total_available: '1',
			},
			user_can_join: true,
			has_joined: false,
			can_eliminate: false,
			can_addon: false,
			can_reenter: false,
		},
	],
	store_tickets_detail: {
		typed_tickets: [],
	},
}
